import React from 'react';
import { Button } from '../../../components/ui/button';

interface ChannelsFiltersModalProps {
    open: boolean;
    onClose: () => void;
    selectedStatus: string;
    setSelectedStatus: (status: string) => void;
    statusOptions: string[];
    onClear: () => void;
    onApply: () => void;
}

const ChannelsFiltersModal: React.FC<ChannelsFiltersModalProps> = ({
    open,
    onClose,
    selectedStatus,
    setSelectedStatus,
    statusOptions,
    onClear,
    onApply,
}) => {
    if (!open) return null;
    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
            <div className="absolute inset-0 bg-black bg-opacity-30 " onClick={onClose} />
            <div className="relative bg-white rounded-2xl shadow-lg w-[55vh] max-w-full flex flex-col">
                {/* Modal Header */}
                <div className="flex items-center bg-gray-100 rounded-tl-2xl rounded-tr-2xl justify-between px-6 py-4 border-b">
                    <span className="font-semibold text-lg text-maxi-text-dark">Filtros</span>
                    <Button
                        variant={"default"}
                        className="text-lg bg-primary rounded-full px-3 shadow"
                        onClick={onClose}
                    >
                        ×
                    </Button>
                </div>
                {/* Modal Content */}
                <div className="px-6 py-6 flex flex-col gap-6">
                    <div>
                        <label htmlFor="status" className="block text-sm font-medium text-maxi-text-dark mb-2">Estado</label>
                        <select
                            id="status"
                            value={selectedStatus}
                            onChange={e => setSelectedStatus(e.target.value)}
                            className="w-[30vh] border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-maxi-green"
                        >
                            <option value="">Selecciona estado</option>
                            {statusOptions.map(opt => (
                                <option key={opt} value={opt}>{opt}</option>
                            ))}
                        </select>
                    </div>
                    <div className="flex gap-3 justify-end mt-4">
                        <Button
                            variant={"secondary"}
                            className="px-4 py-2 rounded-full px-6 font-medium hover:bg-gray-300"
                            onClick={onClear}
                        >
                            Limpiar Filtros
                        </Button>
                        <Button
                            variant={"default"}
                            className="px-4 py-2 rounded-full px-6 font-medium hover:bg-gray-300"
                            onClick={onApply}
                        >
                            Aplicar
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ChannelsFiltersModal;
